import React from 'react';
import { CurrencyFormatterArgs } from './types';
import { useCurrencyFormatter } from './useCurrencyFormatter';

export const FormattedCurrency: React.FC<CurrencyFormatterArgs> = (props) => {
  const { formatCurrency } = useCurrencyFormatter();
  const formattedPrice = formatCurrency(props);

  if (props.formatForm === 'split' && typeof formattedPrice !== 'string') {
    const { currencyCode, amount } = formattedPrice;
    const { showItemSchema } = props ?? {};
    return (
      <>
        {currencyCode?.prefixed && <span>{currencyCode.symbol}</span>}
        <span {...(showItemSchema && { itemProp: 'price' })}>{amount}</span>
        {!currencyCode?.prefixed && <span>{currencyCode.symbol}</span>}
      </>
    );
  }

  return <>{formattedPrice}</>;
};
